import React, { useContext, useRef, useState, useEffect } from "react";
import {
  Modal,
  Input,
  Select,
  Button,
  Row,
  Col,
  Form,
  Divider,
  Upload,
  Alert,
  Result,
  message,
} from "antd";
import ReCAPTCHA from "react-google-recaptcha"; //Using V2
import { forgetPassword } from "../../../apis/authentication";
import PropTypes from "prop-types";
import { InfoCircleOutlined } from "@ant-design/icons";

const ForgotPassword = (props) => {
  const [form] = Form.useForm();
  //   const ContextProvider = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const [success_modal_visible, set_success_modal_visible] = useState(false);
  const reCaptchaRef = useRef();
  const HandleSubmit = async () => {
    const values = await form.validateFields();

    setLoading(true);
    try {
      const res = await forgetPassword(values);
      console.log(res);
      if (res.status === 200) {
        setLoading(false);
        set_success_modal_visible(true);
      } else {
        setLoading(false);
        message.error("Unexpected error");
      }
    } catch (error) {
      setLoading(false);
      reCaptchaRef.current.reset();
      message.error(error.message);
    }
  };

  useEffect(() => {
    return () => {};
  }, [props]);

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      md: { span: 24 },
      xl: { span: 24 },
    },
    wrapperCol: {
      xs: { span: 24 },
      md: { span: 24 },
      xl: { span: 24 },
    },
  };

  const SuccessModal = (
    <Modal visible={success_modal_visible} closable={false} footer={null}>
      <Result
        status="success"
        title="Reset Password Successful!"
        subTitle="An email had sent to your inbox. Please check your Spam / Junk box if you did not receive the email."
        extra={[
          <Button
            type="primary"
            key="login"
            onClick={() => window.location.reload()}
          >
            Back to Login
          </Button>,
        ]}
      />
    </Modal>
  );

  const ForgotPasswordModal = (
    <Row
      type="flex"
      justify="center"
      style={{
        paddingTop: "1vh",
      }}
    >
      <Form {...formItemLayout} form={form}>
        <Row>
          <Col>
            <Alert
              message={
                "If you didn't receive password reset email please check your junk box and spam filter."
              }
              icon={
                <InfoCircleOutlined
                  style={{ color: "#096dd9", fontSize: 16 }}
                />
              }
              showIcon
              style={{
                backgroundColor: "rgba(0,0,0,0.05)",
                borderColor: "rgba(0,0,0,0.15)",
              }}
            />

            <Form.Item
              hasFeedback
              label={"Email Address"}
              name="email"
              rules={[
                {
                  required: true,
                  message: "Email Address is required",
                },
              ]}
              // label={Locale.get("forms.labels.emailAddress")}
              style={{ marginTop: 16 }}
            >
              <Input autoFocus disabled={loading} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row type="flex" justify="center">
              <Form.Item
                hasFeedback
                name="reCaptcha"
                rules={[
                  {
                    required: true,
                    message: "Recaptcha is required",
                    // type: "string"
                  },
                ]}
              >
                <ReCAPTCHA
                  // ref={recaptcha}
                  ref={reCaptchaRef}
                  sitekey="6LcTRr0eAAAAANsQsmNk4yqAP4_jcIFq1j0L2YUR"
                  onChange={(e) => {
                    console.log(e);
                  }}
                />
              </Form.Item>
            </Row>
          </Col>
        </Row>
        <Row type="flex" justify="center">
          <Col>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: 120 }}
              loading={loading}
              onClick={HandleSubmit}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </Row>
  );

  return (
    <div>
      <Modal
        title={"Reset Password"}
        visible={props.visible}
        onCancel={() => props.CloseModal()}
        footer={null}
        centered
      >
        {ForgotPasswordModal}
      </Modal>
      {SuccessModal}
    </div>
  );
};

export default ForgotPassword;
ForgotPassword.propType = {
  visible: PropTypes.bool.isRequired,
  CloseModal: PropTypes.func.isRequired,
};
ForgotPassword.defaultProps = {
  CloseModal: () => {},
};
